(function() {
  // UPDATED VARIABLE NAMES
  if (!window.COMPLIMENTARY_SHADES_PRODUCT || !window.COMPLIMENTARY_SHADES_THRESHOLD_MIN) {
    console.warn('Complimentary Shades: Required variables not set');
    return;
  }

  console.log('Complimentary Shades: Initializing with product', window.COMPLIMENTARY_SHADES_PRODUCT, 'and threshold', window.COMPLIMENTARY_SHADES_THRESHOLD_MIN);
  
  // State variables
  let modal, overlay;
  let selectedVariants = [];
  let variants = [];
  let productData = null;
  let isModalOpen = false;
  let isProcessing = false;
  let previousCartTotal = 0;

  // Initialize the modal system
  function init() {
    document.addEventListener('click', handleAddToCartClick);
    loadProductData();
    startCartMonitoring();
    
    // Add CSS for spinner animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  function handleAddToCartClick(e) {
    if (e.target.closest('.add-to-cart-giftcontainer')) {
      e.preventDefault();
      openModal();
    }
  }

  async function loadProductData() {
    try {
      // UPDATED VARIABLE REFERENCE
      const productHandle = window.COMPLIMENTARY_SHADES_PRODUCT.handle || window.COMPLIMENTARY_SHADES_PRODUCT;
      const response = await fetch(`/products/${productHandle}.js`);
      productData = await response.json();
      variants = productData.variants;
    } catch (error) {
      console.error('Complimentary Shades: Error loading product data', error);
    }
  }

  function startCartMonitoring() {
    // Initial check
    checkCartThreshold();
    
    // Listen for cart events
    const cartEvents = ['cart:updated', 'cart:refresh', 'shopify:section:load', 'ajaxCart:afterCartUpdate'];
    cartEvents.forEach(event => {
      document.addEventListener(event, () => {
        clearTimeout(window.complimentaryShadesDebounce);
        window.complimentaryShadesDebounce = setTimeout(checkCartThreshold, 10);
      });
    });
    
    // Monitor quantity changes
    document.addEventListener('change', (event) => {
      if (event.target.matches('.cart-item__quantity, [name^="updates["]')) {
        setTimeout(checkCartThreshold, 50);
      }
    });
    
    // Periodic check (every 2 seconds)
    setInterval(() => !isProcessing && checkCartThreshold(), 500);
  }

  async function checkCartThreshold() {
    if (isProcessing) return;
    isProcessing = true;
    
    try {
      const cart = await getCart();
      const cartTotal = cart.total_price / 100;
      
      // Skip if no significant change
      if (Math.abs(cartTotal - previousCartTotal) < 100) {
        return;
      }
      
      previousCartTotal = cartTotal;
      
      // UPDATED PROPERTY NAME
      const hasComplimentaryShades = cart.items.some(item => 
        item.properties?._complimentary_shade === 'true'
      );
      
      // UPDATED VARIABLE REFERENCE
      if (cartTotal < window.COMPLIMENTARY_SHADES_THRESHOLD_MIN && hasComplimentaryShades) {
        console.log('Complimentary Shades: Removing shades - cart below threshold');
        await removeComplimentaryShades();
        await updateCartUI();
      }
    } catch (error) {
      console.error('Complimentary Shades: Error checking cart threshold', error);
    } finally {
      isProcessing = false;
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  function createModal() {
    if (overlay) overlay.remove();
    
    // UPDATED IDS AND CLASSES
    overlay = document.createElement('div');
    overlay.id = 'complimentary-shades-overlay';
    overlay.style = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.25);z-index:9998;display:flex;align-items:center;justify-content:center;';
    overlay.addEventListener('click', (e) => e.target === overlay && closeModal());

    modal = document.createElement('div');
    modal.id = 'complimentary-shades-modal';
    modal.style = 'background:#fff;max-width:650px;width:95vw;padding:0;border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.18);position:relative;z-index:9999;text-align:left;display:flex;flex-direction:column;align-items:stretch;overflow:hidden;';
    modal.innerHTML = `
      <button id="complimentary-shades-close" style="position:absolute;top:18px;right:18px;background:none;border:none;font-size:22px;cursor:pointer;z-index:2;">&times;</button>
      <div style="padding:20px 10px 0 20px;text-align:center;margin:0 auto;">
        <h2 style="font-size:1.2em;font-weight:600;margin-bottom:4px;">Add 2 Complimentary Shades</h2>
        <div style="margin-bottom:12px;font-size:1em;">Select 2 shades to include with your order.</div>
      </div>
      <div style="display:flex;align-items:stretch;">
        <div style="flex:0 0 150px;padding:0px 20px;">
          <div id="complimentary-shades-product-img" style="width:140px;height:180px;display:flex;align-items:center;justify-content:center;"></div>
        </div>
        <div style="flex:1;padding:20px 10px 20px 10px;display:flex;flex-direction:column;">
          <div style="font-size:1.1em;font-weight:600;margin-bottom:8px;">${productData?.title || ''}</div>
          <div id="complimentary-shades-swatches" style="display:flex;flex-wrap:wrap;margin-bottom:10px;gap:2px;"></div>
          <div id="complimentary-shades-selected" style="margin-bottom:18px;font-size:1em;"></div>
          <button id="complimentary-shades-add" style="padding:10px 20px;font-size:1em;border:1px solid #222;background:#fff;cursor:pointer;align-self:flex-start;position:relative;">
            <span class="button-text">ADD SHADES</span>
            <span class="loading-spinner" style="display:none;position:absolute;left:50%;top:60%;transform:translate(-50%,-50%);">
              <svg style="width:20px;height:20px;animation:spin 0.8s linear infinite;" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
              </svg>
            </span>
          </button>
        </div>
      </div>
    `;
    
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.getElementById('complimentary-shades-close').onclick = closeModal;
    document.getElementById('complimentary-shades-add').onclick = addSelectedToCart;
    
    renderModalContent();
  }

  function renderModalContent() {
    if (!productData) return;
    
    const imgDiv = document.getElementById('complimentary-shades-product-img');
    imgDiv.innerHTML = `<img src="${productData.images[0]}" alt="${productData.title}" style="max-width:100%;max-height:100%;object-fit:contain;"/>`;
    
    renderSwatches();
    renderSelectedText();
  }

  function renderSwatches() {
    const swatchDiv = document.getElementById('complimentary-shades-swatches');
    if (!swatchDiv || !variants.length) return;
    
    swatchDiv.innerHTML = '';
    
    variants.forEach(variant => {
  const color = getVariantColor(variant);
  const isSelected = selectedVariants.includes(variant.id);
  const isAvailable = variant.available; // Shopify variant availability

  const swatch = document.createElement('label');
  swatch.className = 'shade-option';
  swatch.style.margin = '4px';
  swatch.title = variant.title;

  swatch.innerHTML = `
    <input 
      type="checkbox"
      name="complimentary-shades-variant"
      value="${variant.id}"
      ${isSelected ? 'checked' : ''}
      ${!isAvailable ? 'disabled' : ''}
      style="display:none;"
    >
    <span 
      class="shade-swatch"
      style="
        display:inline-block;
        border-radius:50% 50% 50% 50% / 60% 60% 40% 40%;
        background:${color};
        border:1px solid #ccc;
        vertical-align:middle;
        opacity:${isAvailable ? '1' : '0.4'};
        cursor:${isAvailable ? 'pointer' : 'not-allowed'};
        ${isSelected && isAvailable
          ? 'border-color:#000;box-shadow:0 0 0 2px #fff, 0 0 0 4px #000'
          : ''
        }
      ">
    </span>
  `;

  if (isAvailable) {
    swatch.onclick = (e) => {
      e.preventDefault();
      toggleVariantSelection(variant.id);
    };
  } else {
    swatch.classList.add('is-disabled');
  }

  swatchDiv.appendChild(swatch);
});

  }

  function getVariantColor(variant) {
    if (!variant.option1) return '#e6c1a2';
    const colorName = variant.option1.split(' ')[0];
    return window.theme_custom_colors?.[colorName] || '#e6c1a2';
  }

  function toggleVariantSelection(variantId) {
    if (selectedVariants.includes(variantId)) {
      selectedVariants = selectedVariants.filter(id => id !== variantId);
    } else {
      if (selectedVariants.length >= 2) return;
      selectedVariants.push(variantId);
    }
    renderSwatches();
    renderSelectedText();
  }

  function renderSelectedText() {
    const selDiv = document.getElementById('complimentary-shades-selected');
    if (!selDiv) return;
    
    selDiv.innerHTML = selectedVariants.length === 0 
      ? 'Choose 2 shades to add'
      : selectedVariants.map(id => {
          const variant = variants.find(v => v.id === id);
          return variant ? `<b>${variant.title}</b>` : '';
        }).join(' & ');
  }

  async function addSelectedToCart() {
    if (selectedVariants.length !== 2) {
      alert('Please select exactly 2 shades.');
      return;
    }
    
    const addButton = document.getElementById('complimentary-shades-add');
    if (!addButton) return;
    
    // Show loading spinner
    const buttonText = addButton.querySelector('.button-text');
    const spinner = addButton.querySelector('.loading-spinner');
    
    buttonText.style.visibility = 'hidden';
    spinner.style.display = 'block';
    addButton.disabled = true;
    
    try {
      await removeComplimentaryShades();
      
      // UPDATED PROPERTY NAME
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: selectedVariants[0], quantity: 1, properties: { '_complimentary_shade': 'true' } },
            { id: selectedVariants[1], quantity: 1, properties: { '_complimentary_shade': 'true' } }
          ]
        })
      });

      closeModal();
      await updateCartUI();
      openCartDrawer();
      
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error('Complimentary Shades: Error adding to cart', error);
      alert('Failed to add complimentary shades to cart. Please try again.');
    } finally {
      // Hide loading spinner
      if (buttonText) buttonText.style.visibility = 'visible';
      if (spinner) spinner.style.display = 'none';
      if (addButton) addButton.disabled = false;
    }
  }

  async function removeComplimentaryShades() {
    try {
      const cart = await getCart();
      // UPDATED PROPERTY NAME
      const complimentaryShadeItems = cart.items.filter(item => 
        item.properties?._complimentary_shade === 'true'
      );
      
      if (complimentaryShadeItems?.length === 0) return;
      
      // Create updates array with all items to remove
      const updates = {};
      complimentaryShadeItems.forEach(item => {
        updates[item.key] = 0; // Set quantity to 0 to remove
      });
      
      // Remove all complimentary shades in one API call
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      return true;
    } catch (error) {
      console.error('Complimentary Shades: Error removing complimentary shades', error);
      throw error;
    }
  }

  async function updateCartUI() {
    try {
      const response = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const data = await response.json();
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data['cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data['cart-drawer'];
        const newContent = tempDiv.querySelector('.drawer__inner');
        if (newContent) {
          cartDrawer.querySelector('.drawer__inner').innerHTML = newContent.innerHTML;
        }
        if (typeof cartDrawer.refreshDrawer === 'function') {
          cartDrawer.refreshDrawer();
        }
      }
      
      const cartBubble = document.getElementById('cart-icon-bubble');
      if (cartBubble && data['cart-icon-bubble']) {
        cartBubble.innerHTML = data['cart-icon-bubble'];
      }
    } catch (error) {
      console.error('Complimentary Shades: Error updating cart UI', error);
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.open) cartDrawer.open();
  }

  function openModal() {
    if (isModalOpen) return;
    isModalOpen = true;
    
    getCart().then(cart => {
      // UPDATED PROPERTY NAME
      selectedVariants = cart.items
        .filter(item => item.properties?._complimentary_shade === 'true')
        .map(item => item.variant_id);
      
      createModal();
    }).catch(error => {
      console.error('Complimentary Shades: Error opening modal', error);
      isModalOpen = false;
    });
  }

  function closeModal() {
    if (overlay) overlay.remove();
    isModalOpen = false;
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', init);
})();